<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title">Reset Password</h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-6 offset-md-3 text-center subtitle">Please enter email address to reset password.</div>
</div>
<br />
<div class="row">
  <div class="col-md-4 offset-md-4">
    <div class="card">
      <div class="card-body">
        <h2>Reset Password</h2>
        <div class="col-md-12">
          <form class="form-horizontal" name="resetPasswordForm" #f="ngForm" novalidate
                (ngSubmit)="f.form.valid ? resetPassword() :
                          (!email.valid && showErrorAlert('Email is required', 'Please enter a valid email'));">
            <div class="form-group">
              <label for="resetPasswordInputEmail">Enter Email:</label>
              <input type="email" name="email" class="form-control" id="resetPasswordInputEmail"
                    aria-describedby="resetPasswordInputEmail"placeholder="Email"
                    [(ngModel)]="userEmail" #email="ngModel" required>
              <span class="errorMessage" *ngIf="f.submitted && !email.valid">
                *Email is required!
              </span>
            </div>
            <br />
            <div class="row">
              <div class="col-md-5 offset-md-2 text-right">
                <button type="button" class="btn btn-light btn-block"
                        [routerLink]='["/account/login"]'>
                  Cancel
                </button>
              </div>
              <div class="col-md-5  text-right">
                <button type="submit" class="btn btn-primary  btn-block">Reset Password</button>
              </div>
            </div>
          </form>
        </div>
      
      </div>
    </div>
  </div>
</div>
